// extracted by mini-css-extract-plugin
export default {"teamList":"searchresult_teamList__0g1rY","conferenceList":"searchresult_conferenceList__ablb9","flex":"searchresult_flex__dqIkW","noResult":"searchresult_noResult__uSQ7Q"};